// extracted by mini-css-extract-plugin
export default {"form-button":"styles_form-button__lDhIX"};